import { Currency } from '@mairistem/composants';

import { useUpdateEffect } from '@mairistem/tools';
import React from 'react';

interface MontantProps {
  disabled: boolean;
  autoFocus?: boolean;
  reste: number;
  montant: number;
  onChange: (value: number) => void;
}

const Montant = (props: MontantProps) => {
  const { disabled, autoFocus = false, reste, montant, onChange, ...rest } = props;

  const handleMontantInject = React.useCallback(() => {
    if (reste > 0) {
      if (montant === 0 || montant !== reste) {
        onChange(reste);
      }
    }
  }, [montant, onChange, reste]);

  const handleBlur = React.useCallback(
    (e, value) => {
      onChange(value);
    },
    [onChange],
  );

  const handleKeyDown = React.useCallback(
    (event) => {
      const {
        key,
        target: { value },
      } = event;

      const parsedValue = parseFloat(value || 0);

      // Si aucun montant n'a déjà été saisi avant
      // Et si on est pas en cours de saisi (pas encore sorti du champs après avoir tapé un montant)
      if (parsedValue === 0 && key === '+') {
        handleMontantInject();
      }
    },
    [handleMontantInject],
  );

  const handleIconKeyDown = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleMontantInject();
        event.preventDefault();
      }
    },
    [handleMontantInject],
  );

  useUpdateEffect(() => {
    onChange(montant);
  }, [montant]);

  return (
    <Currency
      {...rest}
      disabled={disabled}
      autoFocus={autoFocus}
      value={montant}
      label="Montant"
      inline
      placeholder=""
      style={{ width: 150 }}
      {...(reste > 0 && { valueMax: reste })}
      valueMin={0}
      description=""
      blurOnEnter={false}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      icon={{
        name: 'calculator',
        basic: true,
        link: true,
        size: 'large',
        fitted: true,
        style: { width: 40 },
        tabIndex: 0,
        role: 'button',
        'aria-label': 'Reprendre la totalité du reste à encaisser',
        onClick: handleMontantInject,
        onKeyDown: handleIconKeyDown,
        title: 'Reprendre la totalité du reste à encaisser',
      }}
      required
    />
  );
};

export default Montant;
